module.exports = __webpack_public_path__ + "img/Avatar-19.9bb933fd.svg";